import { useCallback } from 'react';
import { useTenants } from 'TenantModule/hooks/useTenants';
import type { SearchableOption } from './SearchableSelect';

export const useTenantSearchableSelect = () => {
  const { tenantOrder, tenantsHash } = useTenants({ isOff: false });

  const getOptions = useCallback(
    (queryLC: string): SearchableOption[] => {
      return tenantOrder
        .filter((id) => !tenantsHash[id]?.isArchived)
        .map((id) => tenantsHash[id]?.tenantName || '')
        .filter((name) => (queryLC ? name.toLocaleLowerCase().includes(queryLC) : true))
        .sort((a, b) => a.localeCompare(b))
        .map((tenantName) => ({ value: tenantName, label: tenantName }));
    },
    [tenantOrder, tenantsHash],
  );

  return {
    getOptions,
    defaultLabel: 'Tenant',
    defaultLabelId: 'tenant-select-label',
    defaultPlaceholder: 'Search tenants by name',
  } as const;
};

export default useTenantSearchableSelect;
